// extracted by mini-css-extract-plugin
export default {"timeUnitValue":"_4w9y68","separator":"_1jk10rp","largeCountdown":"_7nbdva","timeUnit":"_wyl2nl","smallCountdown":"_12ewrl6","timeUnitLabel":"_4qrsg3"};